/*@ngInject*/
const UIDraggableColumnDirective = function ($rootScope, formMediator, formViewerConstant) {

    let linkFunction = function ($scope, $elm, $attr) {

        let element = $($elm),
            uiDraggableColumnIdentifier = $attr.uiDraggableColumnIdentifier,
            isDraggable = $attr.uiDraggableColumnIsDraggable === 'true',
            areColumnsBeingResized = false,
            isLeftDropAttempt,
            isRightDropAttempt;

        if (isDraggable) {
            element.attr('draggable', 'true');
        }

        function onMouseEnter(event) {
            if (!areColumnsBeingResized) {
                element.addClass('selectable');
            }
        }

        function onMouseLeave(event) {
            if (!areColumnsBeingResized) {
                element.removeClass('selectable');
            }
        }

        function onDragStart(event) {
            let dataTransfer = event.originalEvent.dataTransfer,
                isDraggingColumn = event.target.className.indexOf('draggableColumn') !== -1,
                dragConfiguration = {
                    columnIdentifier: uiDraggableColumnIdentifier,
                    isDraggingColumn: true
                };

            if (isDraggingColumn) {
                element.addClass('dragging');
                dataTransfer.effectAllowed = 'move';
                event.originalEvent.dataTransfer.setData('text', JSON.stringify(dragConfiguration));
                formMediator.setCurrentDragItem(dragConfiguration);
            }
        }

        function onDragOver(event) {
            let dataTransfer = event.originalEvent.dataTransfer,
                currentDropTarget = $(event.currentTarget),
                isElementBeingDragged = currentDropTarget.hasClass('dragging'),
                previousChild = element.prev(),
                currentDragConfig = formMediator.getCurrentDragItem(),
                isDraggingColumn = !_.isNil(currentDragConfig) && !!currentDragConfig.isDraggingColumn,
                offsetX,
                width,
                horizontalMiddle;

            if (!isElementBeingDragged && isDraggingColumn) {
                offsetX = event.clientX - currentDropTarget.offset().left;
                width = currentDropTarget.width();
                horizontalMiddle = width / 2;
                isLeftDropAttempt = offsetX <= horizontalMiddle;
                isRightDropAttempt = offsetX > horizontalMiddle;

                previousChild.removeClass('dragOverRight');
                element.removeClass('dragOverRight');

                if (isLeftDropAttempt) {
                    previousChild.addClass('dragOverRight');
                } else if (isRightDropAttempt) {
                    element.addClass('dragOverRight');
                }

                dataTransfer.dropEffect = 'move';
                event.preventDefault();
            }
        }

        function onDragLeave() {
            let previousChild = element.prev();

            previousChild.removeClass('dragOverRight');
            element.removeClass('dragOverRight');
        }

        function onDrop(event) {
            let dataTransfer = event.originalEvent.dataTransfer,
                dropConfiguration = JSON.parse(dataTransfer.getData('text')),
                isDraggingColumn = !!dropConfiguration.isDraggingColumn,
                dropZone = $(event.currentTarget),
                dropZonePreviousChild = dropZone.prev(),
                offsetX,
                width,
                horizontalMiddle;

            if (isDraggingColumn) {
                offsetX = event.offsetX;
                width = dropZone.width();
                horizontalMiddle = width / 2;
                isLeftDropAttempt = offsetX < horizontalMiddle;

                if (dropConfiguration.columnIdentifier !== uiDraggableColumnIdentifier) {
                    $rootScope.$broadcast(formViewerConstant.event.formBuilder.REARRANGE_COLUMN, dropConfiguration.columnIdentifier, uiDraggableColumnIdentifier, isLeftDropAttempt);
                }

                dropZonePreviousChild.removeClass('dragOverRight');
                dropZone.removeClass('dragOverRight');

                event.preventDefault();
                return false;
            }
        }

        function onDragEnd() {
            let previousChild = element.prev();

            element.removeClass('dragging');
            previousChild.removeClass('dragOverRight');
            element.removeClass('dragOverRight');
        }

        element.on('mouseenter', onMouseEnter);
        element.on('mouseleave', onMouseLeave);

        if (isDraggable) {
            element.on('dragstart', onDragStart);
            element.on('dragover', onDragOver);
            element.on('dragleave', onDragLeave);
            element.on('drop', onDrop);
            element.on('dragend', onDragEnd);
        }

        $scope.$on(formViewerConstant.event.formBuilder.DISABLE_DRAGGABLE_ELEMENTS, function () {
            if (isDraggable) {
                element.attr('draggable', 'false');
            }
        });

        $scope.$on(formViewerConstant.event.formBuilder.ENABLE_DRAGGABLE_ELEMENTS, function () {
            if (isDraggable) {
                element.attr('draggable', 'true');
            }
        });

        $scope.$on(formViewerConstant.event.formBuilder.COLUMN_RESIZING, function () {
            areColumnsBeingResized = true;
            element.removeClass('selectable');
        });

        $scope.$on(formViewerConstant.event.formBuilder.COLUMN_RESIZED, function () {
            areColumnsBeingResized = false;
        });

        $scope.$on('$destroy', function () {
            element.off('mouseenter', onMouseEnter);
            element.off('mouseleave', onMouseLeave);
            element.off('dragstart', onDragStart);
            element.off('dragover', onDragOver);
            element.off('dragleave', onDragLeave);
            element.off('drop', onDrop);
            element.off('dragend', onDragEnd);
        });
    };

    return {
        link: linkFunction,
        restrict: 'A'
    };
};

angular.module('umFormViewer')
    .directive('uiDraggableColumn', UIDraggableColumnDirective);
